module.exports = __webpack_public_path__ + "static/media/yuchililun.b5c3609e.png";